import React, { useCallback } from 'react';
import { DialogActions, Button, Tooltip } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import CircleProgressButton from '../buttons/CircleProgressButton';
import ExportIcon from '@mui/icons-material/PlayCircleFilledRounded';
import { secondsToDigitalText, secondsToVerboseText } from '../../utilities/timeUtilities';

const styles = theme => ({
    durationButton: {
        color: theme.palette.text.secondary,
        marginRight: 'auto',
    }
});

const ExportActions = React.memo(({
    classes,
    videoSettingsLoading,
    allowedExporting,
    defaultAudio,
    loading,
    duration,
    onStartExport,
    disabled,
    onDurationButtonClick
}) => {
    const handleDurationClick = useCallback(() => {
        onDurationButtonClick();
    }, [onDurationButtonClick]);

    const handleStartExport = useCallback(() => {
        onStartExport();
    }, [onStartExport]);

    if (!videoSettingsLoading && allowedExporting && !defaultAudio) {
        return (
            <DialogActions disableSpacing>
                <Tooltip
                    title={`${secondsToVerboseText(duration)} of audio selected for export.`}
                    placement='top'
                    arrow
                >
                    <Button
                        className={classes.durationButton}
                        aria-label={`${secondsToVerboseText(duration)} of audio selected for export.`}
                        onClick={handleDurationClick}
                    >
                        {secondsToDigitalText(duration)}
                    </Button>
                </Tooltip>
                <CircleProgressButton
                    onClick={handleStartExport}
                    variant='outlined'
                    color='primary'
                    startIcon={<ExportIcon />}
                    loading={loading}
                    disabled={disabled}
                >
                    Start Export
                </CircleProgressButton>
            </DialogActions>
        );
    }

    return null;
});

export default withStyles(ExportActions, styles);
